module.exports = __webpack_public_path__ + "static/media/61.c4021f4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/61.wav
// module id = z1hU
// module chunks = 0